import {
  AfterViewInit,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  ViewChild,
  inject,
  OnInit,
  signal,
  computed,
} from "@angular/core";
import {
  NavigationEnd,
  Router,
  RouterOutlet,
  RouterLink,
  RouterLinkActive,
} from "@angular/router";
import { AuthService, MODES } from "../services/api/auth/auth.service";
import { ThemeService } from "../services/theme/theme.service";
import { Subscription, filter, of } from "rxjs";
import { ModalService } from "../services/modal/modal.service";
import { ContactComponent } from "../modals/contact/contact.component";
import { DocComponent } from "../modals/doc/doc.component";
import { initFlowbite } from "flowbite";
import { DropdownComponent } from "../dashboard/utils/dropdown/dropdown.component";
import { PATH } from "../app.routes";
import { SnackbarService } from "../services/snackbar/snackbar.service";
import { environment } from "../../environments/environment";
import { DataService } from "../services/api/data/data.service";
import { rxResource } from "@angular/core/rxjs-interop";
import { EmailPreferences } from "../modals/email-preferences/email-preferences";
import { Welcome } from "../modals/welcome/welcome";
@Component({
  selector: "app-main",
  standalone: true,
  imports: [
    RouterOutlet,
    DocComponent,
    ContactComponent,
    DropdownComponent,
    RouterLink,
    RouterLinkActive,
    EmailPreferences,
    Welcome,
  ],
  templateUrl: "./main.component.html",
  styleUrl: "./main.component.scss",
})
export class MainComponent implements OnInit, AfterViewInit {
  isDarkMode = false;
  private themeSubscription?: Subscription;
  isNotificationVisible = false;
  isUserDropdownVisible = false;
  PATH = PATH;
  user!: string;
  email!: string;
  userName!: string;
  is_field_email_validation!: boolean;
  allowDemo: boolean = false;
  role = signal<string | null>(null);
  signed_up_clientId = signal<number | null>(null);
  authService = inject(AuthService);
  @ViewChild("helpDocumentsMenu")
  helpDocumentsMenu?: ElementRef<HTMLDetailsElement>;

  readonly allClientsDataForManager$ = rxResource({
    // Signal reads must live in `params` — `stream` is not reactive, so reading
    // role/signed_up_clientId there would evaluate once at construction (while
    // both are still null) and never refetch once the token is decoded.
    params: () => ({
      isManager: this.role() === "MANAGER",
      clientId: this.signed_up_clientId(),
    }),
    stream: ({ params }) =>
      params.isManager && params.clientId ?
        this.dataService.getAllClients()
      : of(null),
    defaultValue: null,
  });
  readonly clientNameForManager = computed(() => {
    if (
      this.allClientsDataForManager$.hasValue() &&
      this.allClientsDataForManager$.value()
    ) {
      const allClients = this.allClientsDataForManager$.value()!;
      const client = allClients.find((c) => c.id === this.signed_up_clientId());
      return client ? client.name : null;
    }
    return null;
  });

  @HostBinding("class") currentClass = "h-screen";
  constructor(
    private router: Router,
    private themeService: ThemeService,
    private modalService: ModalService,
    private snackbarService: SnackbarService,
    private dataService: DataService,
  ) {}

  // Demo mode internal user only dropdown options
  modeOptions: Array<{ key: (typeof MODES)[number]; label: string }> = [
    { key: "demo", label: "Demo Mode" },
    { key: "normal", label: "Live Mode" },
  ];

  ngOnInit() {
    // Check whether login correctly
    const token = this.authService.getToken();
    if (token) {
      const decode = this.authService.getDecodedToken();
      const fn = decode["first_name"] || "";
      const ln = decode["last_name"] || "";
      this.userName =
        [fn, ln].filter(Boolean).join(" ").trim() || decode["email"];
      this.email = decode["email"];
      this.role.set(decode["role"] ?? null);
      this.is_field_email_validation = decode["is_field_email_validation"];
      this.allowDemo =
        !environment.production &&
        (decode["isInternal"] || false) &&
        decode["role"] === "MANAGER";
      this.signed_up_clientId.set(decode["signup_client_id"] ?? null);
    }

    this.themeSubscription = this.themeService.darkMode$.subscribe(
      (isDarkMode) => {
        this.isDarkMode = isDarkMode;
      },
    );

    this.updateMainClass();
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateMainClass();
      });
  }

  updateMainClass() {
    const route = this.router.url;
    //

    if (route === "/dashboard") {
      // this.currentClass = '';  class="p-2.5 pt-[70px] pb-2 md:ml-64 h-screen"
      // this.currentClass = 'p-2.5 pt-[70px] pb-2 md:ml-64 h-screen';
    } else if (route === "/manager/fields-view") {
      // const mainElement = this.el.nativeElement.querySelector('main');
      // this.renderer.removeClass(mainElement, 'h-screen');
      // this.renderer.removeClass(mainElement, 'overflow-hidden');
      // this.renderer.addClass(mainElement, 'h-full');
      // this.renderer.removeClass(mainElement, 'overflow-auto');
    }

    //
  }

  ngOnDestroy() {
    if (this.themeSubscription) {
      this.themeSubscription.unsubscribe();
    }
  }

  ngAfterViewInit() {
    this.initializeDropdown();
    initFlowbite();
  }

  initializeDropdown() {
    const toggleButton = document.querySelector(
      '[data-dropdown-toggle="notification-dropdown"]',
    );
    const dropdown = document.getElementById("notification-dropdown");

    if (toggleButton && dropdown) {
      toggleButton.addEventListener("click", () => {
        dropdown.classList.toggle("hidden");
        dropdown.classList.toggle("block");
      });
    }
  }

  setMode() {
    this.themeService.toggleDarkMode();
  }

  navigateToComponent(routePara?: string) {
    const mode = this.authService.internalModeValue === "demo" ? "demo" : null;
    if (routePara) {
      this.router.navigate([routePara], {
        queryParams: { mode },
        queryParamsHandling: "merge",
      });
    } else {
      let route = "";
      // Check the role
      if (this.role() === "MANAGER") {
        route = "manager/map-view";
      } else if (this.role() === "GROWER") {
        route = "field";
      } else if (this.role() === "ENTITY") {
        route = "entity/map-view";
      }
      this.router.navigate([route], {
        queryParams: { mode },
        queryParamsHandling: "merge",
      });
    }
  }

  redirectToDashboard() {
    const mode = this.authService.internalModeValue === "demo" ? "demo" : null;
    const role = this.authService.getRole();
    let route = "";
    if (role === "GROWER") {
      route = "/dashboard";
    } else if (role === "ENTITY") {
      route = "/entity/fields-view";
    } else if (role === "MANAGER") {
      route = "/manager/fields-view";
    }
    this.router.navigate([route], {
      queryParams: { mode },
      queryParamsHandling: "merge",
    });
  }

  toggleNotification() {
    this.isNotificationVisible = !this.isNotificationVisible;
  }

  signOut(): void {
    this.authService.logout();
    this.snackbarService.show({
      message: "You have been logged out successfully.",
      duration: 3000,
    });
  }

  toggleContactModel() {
    this.modalService.toggleContactModal();
  }

  openEmailPreferencesModel() {
    this.modalService.emailPreferencesModal.set(true);
  }

  openDocFromMenu(
    detailsElement: HTMLDetailsElement,
    fileUrl: string,
    fileName: string,
    title: string = "Documentation",
  ) {
    detailsElement.open = false;
    this.modalService.openDocModal(fileUrl, fileName, title);
  }

  @HostListener("document:click", ["$event"])
  closeHelpDocumentsMenuOnOutsideClick(event: MouseEvent) {
    const menuElement = this.helpDocumentsMenu?.nativeElement;
    const target = event.target as Node | null;

    if (!menuElement || !menuElement.open || !target) {
      return;
    }

    if (!menuElement.contains(target)) {
      menuElement.open = false;
    }
  }

  toggleDocModal(
    fileUrl: string,
    fileName: string,
    title: string = "Documentation",
  ) {
    this.modalService.toggleDocModal(fileUrl, fileName, title);
  }
}
